import React, { useState } from 'react';
import { CheckIcon } from 'lucide-react';
export function NewsletterForm() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!/^\S+@\S+\.\S+$/.test(email)) {
      setStatus('error');
      return;
    }
    setStatus('loading');
    window.setTimeout(() => setStatus('success'), 700);
  };
  if (status === 'success') {
    return <p className="flex items-center gap-2 text-sm text-white" role="status" data-id="element-125" data-mp="1l9va5baaxjmu">
        <CheckIcon className="h-4 w-4 text-accent-bright" aria-hidden="true" data-id="element-126" data-mp="1q14z09o10ixo" /> You’re subscribed. Watch for class openings and clinic dates.
      </p>;
  }
  return <form onSubmit={submit} noValidate data-id="element-127" data-mp="1v2kihxak2hdy">
      <label htmlFor="newsletter-email" className="text-sm text-chrome-300" data-id="element-128" data-mp="200m4or3a2wtn">
        Class openings, clinics and training tips.
      </label>
      <div className="mt-3 flex gap-2" data-id="element-129" data-mp="24wt9ggjxu2a0">
        <input id="newsletter-email" type="email" value={email} onChange={e => {
        setEmail(e.target.value);
        if (status === 'error') setStatus('idle');
      }} placeholder="you@email.com" aria-invalid={status === 'error'} aria-describedby={status === 'error' ? 'newsletter-error' : undefined} className="h-11 min-w-0 flex-1 rounded-[3px] border border-white/20 bg-white/5 px-3 text-sm text-white placeholder:text-chrome-500 focus:border-chrome-300 focus:outline-none" data-id="element-130" data-mp="34qjazut8twhy" />
        <button type="submit" disabled={status === 'loading'} className="h-11 shrink-0 rounded-[3px] bg-accent px-4 font-display text-[13px] font-semibold uppercase tracking-wider text-white hover:bg-accent-bright disabled:opacity-70" data-id="element-131" data-mp="3dqg5id2bdpkx">
          {status === 'loading' ? 'Joining…' : 'Subscribe'}
        </button>
      </div>
      {status === 'error' && <p id="newsletter-error" className="mt-2 text-sm text-[#FF8A8F]" data-id="element-132" data-mp="1ziqkwv5cwpbe">
          Please enter a valid email address.
        </p>}
    </form>;
}